import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
 
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from '../services/ui-services.ts/toaster.service';

export const NetworkConnectionInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToasterService);
  const translate = inject(TranslateService);
  const startTime = Date.now();
  return next(req).pipe(tap(() => {
	const elapsedTime = Date.now() - startTime;
	const threshold = 5000;
	if (elapsedTime > threshold) {
	  toastr.warning(translate.instant('NetWorkConnectionInterceptor.SlowConnection'));
	}
  }));
};
